import { render, staticRenderFns } from "./gui_card.vue?vue&type=template&id=531ae283&"
import script from "./gui_card.vue?vue&type=script&lang=js&"
export * from "./gui_card.vue?vue&type=script&lang=js&"
import style0 from "./gui_card.vue?vue&type=style&index=0&id=531ae283&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports